<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['class_mgt'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-item size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Subject Papers</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(subject)="data">
                {{ data.item.subject.name }}
              </template>
              <template #cell(name)="data">
                <span v-show="data.item.name === 'P1'">Paper One</span> <span v-show="data.item.name == 'P2'">Paper Two</span>
                <span v-show="data.item.name === 'P3'">Paper Three</span> <span v-show="data.item.name == 'P4'">Paper Four</span>
                <span v-show="data.item.name === 'P5'">Paper Five</span> <span v-show="data.item.name == 'P6'">Paper Six</span>
              </template> 
              <template #cell(addedby)="data">
                {{ data.item.addedby }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <!-- <b-button @click="edit(data.item.id, data.item.subject,data.item.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button> -->
                <b-button @click="remove(data.item.id,data.item.name,data.item.code)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    

    <b-modal id="new-item" centered title="New Subject Paper" title-class="font-18" hide-footer>
        <form @submit.prevent="addItem">
            <div class="form-group mb-2">
            <label> Subject </label>
            <multiselect v-model="subject" :options="alevelsubjects" label="name" ></multiselect>
            <label> Paper Name</label>
            <select v-model="name" class="form-control">
                <option value="P1 ">Paper One</option><option value="P2">Paper Two</option>
                <option value="P3">Paper Three</option><option value="P4">Paper Four</option>
                <!-- <option value="P5">Paper Five</option><option value="P6">Paper Six</option> -->
            </select>
            <label>Code</label>
            <input v-model="code" type="text" class="form-control">
           </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-item')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-item" centered title="Edit Class Subject" title-class="font-14" hide-footer>
        <form @submit.prevent="editItem">
            <div class="form-group mb-2">
            <label> Subject </label>
            <multiselect v-model="subject" :options="alevelsubjects" label="name" ></multiselect>
            <label> Paper Name</label>
            <select v-model="name" class="form-control">
                <option value="P1 ">Paper One</option><option value="P2">Paper Two</option>
                <option value="P3">Paper Three</option><option value="P4">Paper Four</option>
                <!-- <option value="P5"></option>Paper Five<option value="P6">Paper Six</option> -->
            </select>
            <label>Code</label>
            <input v-model="code" type="text" class="form-control">
           </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-item')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-item" centered title="Delete Class Subject" title-class="font-18" hide-footer>
        <form @submit.prevent="removeItem">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Subject  Paper: <b>{{ name }} - {{code}}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-item')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal></div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
          </div>
        </div>
      </div>
    </div> 

  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { alevelsubjectsComputed, alevelsubjectsMethods, papersComputed, papersMethods } from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Subject Papers",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader,Multiselect
  },
  data() {
    return {
      title: "Subject Papers",
      items: [ {text: "Dashboard",to: "/",}, {text: "Subject Papers",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,      
      userData:JSON.parse(localStorage.getItem("user")),
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'subject', label: 'Subject', visible: true },
          { key: 'name', label: 'Paper', visible: true },
          { key: 'code', label: 'Paper Code', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'created_at', label: 'Added On', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',created_at:'',subject:'',code:'',
    };
  },
  computed: {
    ...alevelsubjectsComputed,
    ...papersComputed,
    List() { return this.papers.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.papers.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.papers.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchAlevelSubjects();
    this.fetchPapers();
    this.TotalRows = this.papers.length;
    this.isBusy=false;
  },
  methods: {
    ...alevelsubjectsMethods,
    ...papersMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // edit(id,subject,name){
    //   this.id=id;
    //   this.subject=subject;
    //   this.name=name;
    //   this.$bvModal.show('edit-item')
    // },
    remove(id,name,code){
      this.id=id;
      this.name=name;
      this.code=code;
      this.$bvModal.show('delete-item')
    },
    async addItem() { 
      let formData = new FormData();
      formData.append("subject", this.subject.id);
      formData.append("name", this.name);
      formData.append("code", this.code);
      let url = "/addpapers";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchPapers();
          this.$bvModal.hide('new-item');
          this.name="";
          this.subject="";
          this.$swal({ title:'Success', text:response.data.message, icon:'success'});
      }
      });
    },
    // async editItem(){ 
    // let formData = new FormData();
    // formData.append("id", this.id);
    // formData.append("subject", this.subject.id);
    // formData.append("name", this.name);
    // let url = "/updatepaper";
    // await axios.post(url, formData).then((response) => {
    //   if (response.status == 200) {
    //     this.fetchPapers();
    //     this.$bvModal.hide('edit-item');
    //     this.name="";
    //     this.subject="";
    //     this.$swal({ title:'Success', text:response.data.message, icon:'success'});
    //   }
    // });
    // },
    async removeItem() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removepaper";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchAlevelSubjects();
        this.$bvModal.hide('delete-item');
          this.$swal({ title:'Success', text:response.data.message, icon:'success'});
      }
    });
    },
  },
};
</script>